import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import { TerminalProvider } from "@/lib/terminal";
import Layout from "@/components/Layout";
import Pulse from "@/pages/Pulse";
import TokenPage from "@/pages/TokenPage";
import BotPage from "@/pages/BotPage";
import WalletsPage from "@/pages/WalletsPage";
import HistoryPage from "@/pages/HistoryPage";
import AuthShell from "@/components/AuthShell";

const Protected = ({ children }) => (
  <>
    <Show when="signed-in">
      <TerminalProvider>{children}</TerminalProvider>
    </Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={<AuthShell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthShell>} />
            <Route path="/sign-up/*" element={<AuthShell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthShell>} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Pulse />} />
              <Route path="/token/:address" element={<TokenPage />} />
              <Route path="/bot" element={<BotPage />} />
              <Route path="/wallet" element={<WalletsPage />} />
              <Route path="/history" element={<HistoryPage />} />
            </Route>
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
